import React, { useEffect, useState } from 'react';
import { Table, Row, Col, Popover, OverlayTrigger } from "react-bootstrap";
import DatePicker from 'react-date-picker';
import Select from 'react-select';
import { toast } from 'react-toastify';

import { ConsultaDisp, guardarDir } from '../../funciones/PefilFunction';

let fechaD = new Date();
const PerfilCtrlEst = (props) => {
    const [valorSex, setValorSex] = useState({ value: 'M', label: 'Masculino' });
    const [selectNac, setSelectNac] = useState({ value: 'V', label: 'V' });
    const [cedula, setCedula] = useState({ text: '', disabled: true });
    const [cedula2, setCedula2] = useState('');
    const [pasaporte, setPasaporte] = useState({ text: '', disabled: true });
    const [pasaporte2, setPasaporte2] = useState('');
    const [nombre1, setNombre1] = useState({ text: '', disabled: true });
    const [nombre2, setNombre2] = useState({ text: '', disabled: true });
    const [apellido1, setApellido1] = useState({ text: '', disabled: true });
    const [apellido2, setApellido2] = useState({ text: '', disabled: true });
    const [tlf1, setTlf1] = useState({ text: '', disabled: true });
    const [tlf2, setTlf2] = useState({ text: '', disabled: true });
    const [fecha, setFecha] = useState(fechaD);
    const [cantErrores, setCantErrores] = useState('');
    const [btn1, setBtn1] = useState({icon: "fa fa-save", text: "Guardar", disabled: false});
    

    const nac = [
        { value: 'V', label: 'V' },
        { value: 'E', label: 'E' },
    ];

    const Sex = [
        { value: 'M', label: 'Masculino' },
        { value: 'F', label: 'Femenino' },
    ];

    useEffect(() => {
        let data = props.datos;
        const sex = Sex.find(option => option.value === data.sexo);
        const nacionalidad = nac.find(option => option.value === data.nacionalidad);
        let fechaN = new Date(data.f_nac);

        setValorSex(sex)
        setSelectNac(nacionalidad)
        setCedula({ text: data.ci, disabled: false })
        setCedula2(data.ci)
        setPasaporte({ text: data.pasaporte, disabled: false })
        setPasaporte2(data.pasaporte)
        setNombre1({ text: data.nombre_1, disabled: false })
        setNombre2({ text: data.nombre_2, disabled: false })
        setApellido1({ text: data.apellido_1, disabled: false })
        setApellido2({ text: data.apellido_2, disabled: false })
        setApellido2({ text: data.apellido_2, disabled: false })
        setTlf1({ text: data.tlf_hab, disabled: false })
        setTlf2({ text: data.tlf_cel, disabled: false })
        setFecha(fechaN)

    }, [props]);

    let valorSelectSex = (valorSex) => {setValorSex(valorSex)}
    let valorSelectNac = (selectNac) => {setSelectNac(selectNac)}

    let busquedaDat = (campo) => (e) => {
        if (e.target.value === "") return null;
        
        switch(campo){
            case "cedula":
                if (parseInt(cedula.text) === cedula2) return null;

                setBtn1(state => ({...state, disabled: true}))
                ConsultaDisp (cedula.text, campo, (resp)=> {
                    setBtn1(state => ({...state, disabled: false}))
                    if(resp > 0){
                        toast.error(`El documento ${(campo).toUpperCase()} ya está registrado con otro usuario, por favor ingresa otro`,{autoClose: 4000});
                        setCedula(state => ({...state, text: ""}))
                    }
                })
            break;
            case "pasaporte":
                if (parseInt(pasaporte.text) === pasaporte2) return null;

                setBtn1(state => ({...state, disabled: true}))
                ConsultaDisp (pasaporte.text, campo, (resp)=> {
                    setBtn1(state => ({...state, disabled: false}))
                    if(resp > 0){
                        toast.error(`El documento ${(campo).toUpperCase()} ya está registrado con otro usuario, por favor ingresa otro`,{autoClose: 4000});
                        setPasaporte(state => ({...state, text: ""}))
                    }
                })
            break;
            default: return null
        }
    }

    let cambiaFecha = (date) => {setFecha(date)}

    let respGuardar = (resp) => {
        let states = resp[0]
        let mensaje = resp[1]
        let errores = resp[2]
        let nameErrores = resp[3]
        let contentErr = []

        for (let i in nameErrores) {
            if (nameErrores[i] !== "") contentErr.push(
                <div key = {i} className="text-danger" style={{fontSize:10, marginBottom:8}}><i className="fa fa-exclamation-triangle"></i> {nameErrores[i]}</div>
            )
        }

        let help1 = (
            <Popover bsSize="large" title="Errores Encontrados" id="erroresList">
                {contentErr}
            </Popover>
        )

        switch (mensaje[0].status) {
            case "error":
                toast.error(mensaje[0].mensaje,{autoClose: 4000});
                setCantErrores(
                    <div style={{paddingTop:10}}>
                        Se han encontrado {errores} error(es). Haz click <span>
                        <OverlayTrigger trigger="focus" placement="top" overlay={help1}>
                                <button style={{borderWidth: 1}} className="btn btn-danger btn-xs">Aqui</button> 
                        </OverlayTrigger></span> para verlos
                    </div>
                )
                setBtn1({icon: "fa fa-save", text: "Guardar", disabled: false});
            break;
            case "warning":
                toast.warning(mensaje[0].mensaje,{autoClose: 4000});
            break;
            case "info": 
                toast.info(mensaje[0].mensaje,{autoClose: 4000});
                setBtn1({icon: "fa fa-save", text: "Guardar", disabled: false});
            break;
            default: return null;
        }
    }

    let guardar = () => {
        setBtn1({icon: "fa fa-spinner fa-spin", text: "Guardando", disabled: true});
        const campos = {
            valorSex, selectNac, cedula, pasaporte, nombre1, nombre2, apellido1, apellido2, tlf1, tlf2, fecha
        }

        guardarDir(campos, (resp) => {respGuardar(resp) })
    }

    return(
        <Row style={{color:"#9a9a9a"}}>
            <Col md ={12}>
                <div className="custom-alert-info" style={{padding: 5}}>
                    <Row>
                        <Col md ={7} style={{marginTop:10}}>Datos Personales</Col>
                        <Col md ={5}>
                        <Select
                            isSearchable ={true}
                            value={valorSex}
                            onChange={valorSelectSex}
                            options={Sex}
                        />
                        </Col>
                    </Row>
                </div>
            </Col>
            <Col md ={6} className="custom-mt-10"><div className="text-muted">Cédula</div></Col>
            <Col md ={3} className="custom-mt-10"><div className="text-muted">Pasaporte</div></Col>
            <Col md ={3} className="custom-mt-10"><div className="text-muted">Fecha de Nacimiento</div></Col>
            <Col md ={2} style={{marginTop:1}}>
                <Select
                    isSearchable ={true}
                    value={selectNac}
                    onChange={valorSelectNac}
                    options={nac}
                />
            </Col>
            <Col md ={4}>
                <input type="text" value={cedula.text} disabled ={cedula.disabled} onBlur={busquedaDat("cedula")} onChange={(e) => {
                    let str = e.target.value
                    setCedula(state => ({...state, text: str}))
                }} className="form-control" placeholder="* DOCUMENTO DE IDENTIDAD"/>
            </Col>
            <Col md ={3}>
                <input type="text" value={pasaporte.text} disabled ={pasaporte.disabled} onBlur={busquedaDat("pasaporte")} onChange={(e) => {
                    let str = e.target.value
                    setPasaporte(state => ({...state, text: str}))
                }} className="form-control" placeholder="PASAPORTE"/>
            </Col>
            <Col md ={3}>
                <DatePicker
                    clearIcon= {<i className="fa fa-times"></i>}
                    calendarIcon= {<i className="fa fa-calendar"></i>}
                    className="form-control"
                    onChange={cambiaFecha}
                    value={fecha}
                />
            </Col>
            <Col md ={6} className="custom-mt-10"><div className="text-muted">Primer Nombre</div></Col>
            <Col md ={6} className="custom-mt-10"><div className="text-muted">Segundo Nombre</div></Col>
            <Col md ={6}>
                <input type="text" value = {nombre1.text} onChange={(e) => {
                    let str = e.target.value
                    setNombre1(state => ({...state, text: str.toUpperCase()}))
                }} className="form-control" placeholder = "ESCRIBA EL NOMBRE"/>
            </Col>
            <Col md ={6}>
                <input type="text" value = {nombre2.text} onChange={(e) => {
                    let str = e.target.value
                    setNombre2(state => ({...state, text: str.toUpperCase()}))
                }} className="form-control" placeholder = "ESCRIBA EL NOMBRE"/>
            </Col>
            <Col md ={6} className="custom-mt-10"><div className="text-muted">Primer Apellido</div></Col>
            <Col md ={6} className="custom-mt-10"><div className="text-muted">Segundo Apellido</div></Col>
            <Col md ={6}>
                <input type="text" value = {apellido1.text} onChange={(e) => {
                    let str = e.target.value
                    setApellido1(state => ({...state, text: str.toUpperCase()}))
                }} className="form-control" placeholder = "ESCRIBA EL APELLIDO"/>
            </Col>
            <Col md ={6}>
                <input type="text" value = {apellido2.text} onChange={(e) => {
                    let str = e.target.value
                    setApellido2(state => ({...state, text: str.toUpperCase()}))
                }} className="form-control" placeholder = "ESCRIBA EL APELLIDO"/>
            </Col>
            <Col md ={3} className="custom-mt-10"><div className="text-muted">Tlf. Habitación</div></Col>
            <Col md ={9} className="custom-mt-10"><div className="text-muted">Tlf. Celular</div></Col>
            <Col md ={3}>
                <input type="text" value = {tlf1.text} onChange={(e) => {
                    let str = e.target.value
                    setTlf1(state => ({...state, text: str}))
                }} className="form-control" placeholder = "TELEFONO HABITACIÓN"/>
            </Col>
            <Col md ={3}>
                <input type="text" value = {tlf2.text} onChange={(e) => {
                    let str = e.target.value
                    setTlf2(state => ({...state, text: str}))
                }} className="form-control" placeholder = "TELÉFONO CELULAR"/>
            </Col>
            <Col md ={6}><div className="text-danger">{ cantErrores }</div></Col>
            <Col md = {12} className="custom-mt-10" align = "right"><button className = "btn btn-primary" disabled = {btn1.disabled} onClick = {guardar} style = {{borderWidth: 1, marginRight: 6}}><i className = {btn1.icon}></i> {btn1.text}</button></Col>
        </Row>
    )
}

export default PerfilCtrlEst;


// WEBPACK FOOTER //
// ./src/views/Perfil/PerfilCtrlEst.jsx